export enum SlotStatusEnum {
  selected = 'selected',
  normal = 'normal',
  unavailable = 'unavailable',
}

export type SlotStatusTypes = keyof typeof SlotStatusEnum;
